import React from "react";
import HomeHeader from "../components/HomeHeader";
import MobNavbar from "../components/MobNavbar";
import { useMediaQuery } from "react-responsive";
import Breadcrumbs from "../components/Breadcrumbs";

import destinyStyles from "../styles/Destiny.module.css";
import SectionDisplay from "../components/Main/SectionDisplay";
import Back from "../components/Back";
import { useNavigate } from "react-router-dom";

const path = [
  { label: "Home", url: "/" },
  { label: "Honeypot Checker", url: "/" },
  { label: "Results", url: "/" },
];

export default function Destiny() {
  const isMobile = useMediaQuery({
    maxWidth: 768,
  });
  const navigation = useNavigate();

  return (
    <>
      <HomeHeader />
      <MobNavbar />
      <div className={destinyStyles.container}>
        <div className={`flex sb al-ce back-component`}>
          <Back path={"/main"} />

          {!isMobile && <Breadcrumbs path={path} />}
        </div>
        <div className={destinyStyles.coin}>
          <img src={require("../assets/images/coinLeft.png")} alt="coin" />
        </div>
        <div className={destinyStyles.coinRight}>
          <img src={require("../assets/images/coinRight.png")} alt="coin" />
        </div>
        <div className={`flex al-ce ${destinyStyles.section}`}>
          <h1 className={destinyStyles.title}>choose your destiny</h1>

          <div className={destinyStyles.left}>
            <div className={destinyStyles.leftBg}></div>
            <SectionDisplay
              title="pepeai holders analysis"
              onClick={() => navigation("/holders")}
            />
            <div className={destinyStyles.option1}>
              - lorem ipsum dolor sit amet
            </div>
            <div className={destinyStyles.option2}>
              - consequeor dana mini do es
            </div>
          </div>
          <div className={destinyStyles.right}>
            <div className={destinyStyles.rightBg}></div>
            <SectionDisplay title="cointrendz" />
            <div className={destinyStyles.option1}>
              -- lorem ipsum dolor sit amet
            </div>
            <div className={destinyStyles.option2}>
              - consequeor dana mini do es
            </div>
            <div>-- lorem ipsum dolor sit amet</div>
          </div>
        </div>
      </div>
    </>
  );
}
